import { sendApiClientRequest } from "../../api/api";

const BASE = "/api/website-announcements";

const extractErrorMessage = (body, fallback) => {
  const msg = body?.msg;
  if (msg === "json_value") {
    const data = body?.data;
    if (data && typeof data === "object" && !Array.isArray(data)) {
      const firstKey = Object.keys(data)[0];
      if (firstKey) {
        const firstField = data[firstKey];
        if (Array.isArray(firstField) && firstField.length > 0) {
          return String(firstField[0]);
        }
        if (typeof firstField === "string" && firstField) {
          return firstField;
        }
      }
    }
  }
  if (typeof msg === "string" && msg) return msg;
  if (msg != null) return JSON.stringify(msg);
  return fallback;
};

const unwrap = (res) => {
  if (!res || res.status >= 400) {
    throw new Error(extractErrorMessage(res?.data, "請求失敗"));
  }

  const body = res.data;
  if (!body || typeof body !== "object") {
    return null;
  }
  if (body.error) {
    throw new Error(extractErrorMessage(body, "錯誤"));
  }
  return body.data !== undefined ? body.data : null;
};

export const fetchWebsiteAnnouncementsList = async ({
  search = "",
  page = 1,
  limit = 15,
  is_published,
  is_draft,
  display_type,
} = {}) => {
  const params = new URLSearchParams();

  if (typeof search === "string" && search.trim()) {
    params.set("search", search.trim());
  }

  if (typeof is_published === "boolean") {
    params.set("is_published", String(is_published));
  }

  if (typeof is_draft === "boolean") {
    params.set("is_draft", String(is_draft));
  }

  if (
    typeof display_type === "string" &&
    ["fullscreen", "popover", "banner"].includes(display_type)
  ) {
    params.set("display_type", display_type);
  }

  params.set("page", String(page));
  params.set("limit", String(limit));

  const res = await sendApiClientRequest("GET", `${BASE}?${params.toString()}`);
  return unwrap(res);
};

export const fetchWebsiteAnnouncementById = async (id) => {
  const res = await sendApiClientRequest("GET", `${BASE}/${id}`);
  return unwrap(res);
};

export const createWebsiteAnnouncement = async (payload) => {
  const res = await sendApiClientRequest("POST", BASE, payload);
  return unwrap(res);
};

export const updateWebsiteAnnouncement = async (id, payload) => {
  const res = await sendApiClientRequest("PATCH", `${BASE}/${id}`, payload);
  return unwrap(res);
};

export const deleteWebsiteAnnouncement = async (id) => {
  const res = await sendApiClientRequest("DELETE", `${BASE}/${id}`);
  return unwrap(res);
};
